import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Mainnav/sgds-mainnav-item";
import { register } from "../../utils/ce-registry";

register("sgds-mainnav-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-mainnav-item",
  elementClass: Component,
  events: {}
});
